import apiClient from '../api/apiClient'

export interface ReturnLineInput {
  bill_item_id: string
  quantity_pcs: number
}

export interface ReturnDraft {
  bill_id: string
  items: ReturnLineInput[]
  cash_amount: number
}

export interface ReturnEligibilityLine {
  bill_item_id: string
  sku_id: string
  sold_pcs: number
  returned_pcs: number
  available_pcs: number
  sold_ctn: number
  full_credit_amount: number
}

export interface ReturnEligibility {
  bill_id: string
  items: ReturnEligibilityLine[]
  paid_amount: number
  returned_amount: number
  remaining_balance: number
}

export interface ReturnQuote {
  items: (ReturnLineInput & {
    sku_id: string
    quantity_ctn: number
    credit_amount: number
    base_amount: number
    sales_tax_amount: number
    adv_tax_amount: number
    stock_restored: boolean
  })[]
  credit_amount: number
  base_amount: number
  sales_tax_amount: number
  adv_tax_amount: number
  cash_amount: number
  remaining_balance: number
}

export interface SaleReturn extends ReturnQuote {
  _id: string
  company_id: string
  customer_id: string
  bill_id: string
  reason: string
  return_date: string
  recorded_by: string
  cash_payment_id: string | null
  is_reversed: boolean
  reversed_at: string | null
  reversal_reason: string
}

export const saleReturnService = {
  async getEligibility(billId: string): Promise<ReturnEligibility> {
    const response = await apiClient.get<ReturnEligibility>(`/admin/sale-returns/eligibility/${billId}`)
    return response.data
  },
  async quote(draft: ReturnDraft): Promise<ReturnQuote> {
    const response = await apiClient.post<ReturnQuote>('/admin/sale-returns/quote', draft)
    return response.data
  },
  async create(draft: ReturnDraft & { request_key: string; reason?: string; return_date?: string }): Promise<{ sale_return: SaleReturn }> {
    const response = await apiClient.post<{ sale_return: SaleReturn }>('/admin/sale-returns', draft)
    return response.data
  },
  async list(params: { bill_id?: string; customer_id?: string }): Promise<{ results: SaleReturn[] }> {
    const response = await apiClient.get<{ results: SaleReturn[] }>('/admin/sale-returns', { params })
    return response.data
  },
  async reverse(id: string, reason?: string): Promise<void> {
    await apiClient.post(`/admin/sale-returns/${id}/reverse`, { reason })
  },
}
